const hasContexts = (/** @type {Array<string>} */ contexts) => contexts.every(context => window.contexts.includes(context));

import widgetsMgr from 'widgets/widgetsMgr';

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['checkout']),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'checkout.afterpay' */ './widgets/checkout/PaymentAccordionItemAFTERPAY').then(d => d.default)
        ]).then(deps => {
            const [PaymentAccordionItemAFTERPAY] = deps;

            return {
                listId: 'checkout.afterpay',
                widgetsDefinition: () => [['paymentAccordionItemAFTERPAY', PaymentAccordionItemAFTERPAY, 'paymentAccordionItem']]
            };
        })
});

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['pdp']),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'product.afterpay' */ './widgets/product/AfterpayProductDetail').then(d => d.default),
            import(/* webpackChunkName: 'product.afterpay' */ './widgets/product/AfterpayProductSet').then(d => d.default)
        ]).then(deps => {
            const [AfterpayProductDetail, AfterpayProductSet] = deps;

            return {
                listId: 'product.afterpay',
                widgetsDefinition: () => [
                    ['productDetail', AfterpayProductDetail, 'productDetail'],
                    ['productSet', AfterpayProductSet, 'productSet']
                ]
            };
        })
});
